import React from 'react';
import NotificationItem from './NotificationItem';
import './Notifications.css';

const NotificationContainer = ({ notifications, onRemove }) => {
  // Separate errors from other notifications
  const errorNotifications = notifications.filter(n => n.type === 'error');
  const otherNotifications = notifications.filter(n => n.type !== 'error');

  return (
    <>
      {/* Error notifications: top-center banner */}
      {errorNotifications.length > 0 && (
        <div className="notification-error-container">
          {errorNotifications.map(notification => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onRemove={onRemove}
            />
          ))}
        </div>
      )}

      {/* Success/Info/Warning notifications: top-right toast */}
      {otherNotifications.length > 0 && (
        <div className="notification-container">
          {otherNotifications.map(notification => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onRemove={onRemove}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default NotificationContainer;
